<template>
  <MessageLayout
    image="./email-cloud.svg"
    altText="verify email error"
    title="Sorry!"
  >
    There was an issue with your email verification, please try again or contact
    us to get help.
    <template v-slot:action>
      <ResendEmail />
    </template>
  </MessageLayout>
</template>

<script lang="ts">
import { Options, Vue } from "vue-class-component";
import MessageLayout from "@/modules/messages/MessageLayout.vue";
import ResendEmail from "@/modules/ResendEmail.vue";
import store from "@/store";

@Options({
  components: { ResendEmail, MessageLayout },
})
export default class VerifyEmailError extends Vue {
  $store = store;

  get email(): string {
    return this.$store.getters.prospect;
  }
}
</script>
